import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKlarna = (props) => /* @__PURE__ */ _jsxs("svg", {
	"aria-hidden": "true",
	focusable: "false",
	"data-prefix": "fab",
	"data-icon": "klarna",
	className: "svg-inline--fa fa-klarna",
	role: "img",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 640 512",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "st0",
		fill: "#ffa8cd",
		d: "M563.8,121.3H76.2C34.1,121.3,0,155.4,0,197.4v117.1c0,42.1,34.1,76.2,76.2,76.2h487.6c42.1,0,76.2-34.1,76.2-76.2v-117.1c0-42.1-34.1-76.2-76.2-76.2Z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "st1",
		fill: "#0b051d",
		d: "M515.7,293.2c-11.2,0-19.9-9.2-19.9-20.5s8.7-20.5,19.9-20.5,19.9,9.2,19.9,20.5-8.7,20.5-19.9,20.5ZM510.1,314.8c9.5,0,21.7-3.6,28.4-17.8l.7.3c-3,7.8-3,12.4-3,13.5v1.8h24v-79.9h-24v1.8c0,1.2,0,5.8,3,13.5l-.7.3c-6.7-14.2-18.9-17.8-28.4-17.8-22.8,0-38.9,18.1-38.9,42.1s16.1,42.1,38.9,42.1ZM429.4,230.7c-10.8,0-19.4,3.8-26.3,17.8l-.7-.3c3-7.8,3-12.4,3-13.5v-1.8h-24v79.9h24.6v-42.1c0-11.1,6.4-18,16.8-18s15.4,5.9,15.4,17.8v42.2h24.6v-50.8c0-18.1-14.1-31.2-33.5-31.2ZM345.8,248.5l-.7-.3c3-7.8,3-12.4,3-13.5v-1.8h-24v79.9h24.6l.2-38.4c0-11.2,5.9-18,15.6-18s4.8.3,7.2,1v-24.4c-10.8-2.3-20.5,1.8-26,15.7ZM267.4,293.2c-11.2,0-19.9-9.2-19.9-20.5s8.7-20.5,19.9-20.5,19.9,9.2,19.9,20.5-8.7,20.5-19.9,20.5ZM261.8,314.8c9.5,0,21.7-3.6,28.4-17.8l.7.3c-3,7.8-3,12.4-3,13.5v1.8h24v-79.9h-24v1.8c0,1.2,0,5.8,3,13.5l-.7.3c-6.7-14.2-18.9-17.8-28.4-17.8-22.8,0-38.9,18.1-38.9,42.1s16.1,42.1,38.9,42.1ZM188.5,312.7h24.6v-115.5h-24.6v115.5ZM170.5,197.2h-25.1c0,20.6-12.7,39.1-31.9,52.3l-7.6,5.3v-57.6h-26.1v115.5h26.1v-57.3l43.2,57.3h31.9l-41.6-54.8c18.9-13.7,31.2-35,31.1-60.7Z"
	})]
});
export default SvgKlarna;
